import React, { useRef } from "react";
import { Outlines, useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/plots/07-Townhouses.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }
  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
       <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube226.geometry}
        material={materials["00-Base3"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube227.geometry}
        material={materials["12-TownhomeBuilding1"]}
        position={[-0.671, 0.682, 0.379]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube228.geometry}
        material={materials["10-ResidentialSiding"]}
        position={[-0.671, 0.284, 0.379]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube302.geometry}
        material={materials["12-TownhomeBuilding2"]}
        position={[-0.671, 0.682, -0.289]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube350.geometry}
        material={materials["11-SidewalkConcrete"]}
        position={[0.085, 0.101, -0.916]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube374.geometry}
        material={materials["12-TownhomeBuilding3"]}
        position={[0.52, 0.682, -0.674]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube376.geometry}
        material={materials["00-Grass1"]}
        position={[-0.498, 0.099, -0.699]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube454.geometry}
        material={materials["12-TownhomeSteps"]}
        position={[0.52, 0.142, -0.3]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube457.geometry}
        material={materials["12-TownhomeBasements"]}
        position={[0.52, 0.682, -0.674]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube460.geometry}
        material={materials["12-TownhomeRoofs"]}
        position={[0.52, 1.271, -0.674]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube462.geometry}
        material={materials["12-PorchSteps"]}
        position={[0.42, 0.252, -0.212]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube473.geometry}
        material={materials["07-WindowMat"]}
        position={[0.319, 0.534, -0.373]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={1.233}
      ><Outlines thickness={outlineThickness}/></mesh>
      <group position={[0.817, 1.063, -0.829]} scale={1.233}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube534.geometry}
          material={materials["06-WindowSill2"]}
        ><Outlines thickness={outlineThickness}/></mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube534_1.geometry}
          material={materials["10-ResidentialSiding"]}
        ><Outlines thickness={outlineThickness}/></mesh>
      </group>
    </group>
  );
}

useGLTF.preload("/plots/07-Townhouses.glb");
